import CityPage from "../CityPage";

export default function ProspectHeights() {
  return <CityPage slug="prospect-heights" />;
}
